import React from "react";
import { Formik, Field, Form, ErrorMessage } from "formik";
import { Link } from "react-router-dom";
import formatDate from "../../../util/FormateDate";
import * as Yup from "yup";
import thurentlogo from "../../../redesign/assets/thurent-logo.svg"


  const RSVPValidationSchema = Yup.object().shape({
    name: Yup.string().required("Name is required"),
    mobile: Yup.string()
      .matches(/^[6-9]\d{9}$/, "Enter a valid mobile number")
      .required("Mobile number is required"),
    attendance: Yup.string().required("Please select your attendance"),
    members: Yup.number()
      .min(1, "Must be at least 1 member")
      .max(25, "Max people allowed is 25. If more than 25 are attending, please call the host and let them know.")
      .required("Number of members is required"),
  });

const RSVPCard = ({
  eventType,
  invitedBy,
  startDate,
  venue,
  styleConfig = {},
  onSubmitForm, // callback for handling form submit
}) => {
  // Default styles
  const defaultStyles = {
    cardBackground: "#fff",
    headingColor: "#222",
    headingFontSize: "20px",
    textColor: "#444",
    padding: "16px",
    venueFontSize: "14px",
  };

  const styles = { ...defaultStyles, ...styleConfig };

  return (
    <div
      className="rsvp-invitation-inner"
      style={{
        
        padding: styles.padding,
        color: styles.textColor,
      }}
    >
      {/* Invitation Header */}
      <div className="rsvp-invitation-card-new">
        {eventType && (
          <div className="rsvp-invitation-head">
            <div style={{ paddingBottom: "8px" }}>You've been invited to</div>
            <div
              className="event-name-new"
              style={{ color: styles.headingColor, fontSize: styles.headingFontSize }}
            >
              {eventType}
            </div>

            {startDate && (
              <div className="datetime-new">
                <i className="sub-heading-new">on</i> {formatDate(startDate)}
              </div>
            )}

            <div className="inviteby-new">
              <i className="sub-heading-new">By</i>
            </div>
            <div className="event-name-new">{invitedBy}</div>

            {venue && (
              <div
                className="location-new"
                style={{ display: "flex", flexDirection: "column" }}
              >
                <i className="sub-heading-new">at</i>
                <span
                  style={{
                    fontSize: styles.venueFontSize,
                    display: "inline-block",
                    // width: "400px",
                    wordWrap: "break-word",
                    whiteSpace: "normal",
                    marginTop: "8px",
                  }}
                >
                  {venue}
                </span>
              </div>
            )}

            <div className="content-of-confirm">
              <p>Kindly confirm through the form below</p>
            </div>
          </div>
        )}
      </div>

      {/* RSVP Form */}
      <div className="rsvp-invitation-form-new">
        <Formik
          initialValues={{
            name: "",
            mobile: "",
            attendance: "yes",
            remind: "yes",
            members: 1,
            suggestion: "",
          }}
          validationSchema={RSVPValidationSchema}
          onSubmit={(values,formikHelpers) => {
            if (onSubmitForm) {
              onSubmitForm(values,formikHelpers);
            }
            console.log("RSVP Submitted:", values);
          }}
        >
          {({ values }) => (
            <Form className="rsvp-form-new">
              <div
              className="userdetails"
              >
                {/* Name */}
                <div style={{ marginRight: "5px", width: "100%" }}>
                  <Field
                    type="text"
                    name="name"
                    placeholder="Name"
                    className="rsvp-input-new"
                  />
                  <ErrorMessage
                    className="rsvp-error"
                    name="name"
                    component="div"
                    style={{ color: "red", fontSize: "12px" }}
                  />
                </div>

                {/* Mobile */}
                <div style={{ marginRight: "5px", width: "100%" }}>
                  <Field
                    type="tel"
                    name="mobile"
                    placeholder="Mobile Number"
                    className="rsvp-input-new"
                  />
                  <ErrorMessage
                    className="rsvp-error"
                    name="mobile"
                    component="div"
                    style={{ color: "red", fontSize: "12px" }}
                  />
                </div>
              </div>

                            {/* Attendance + Reminder */}
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "2fr 1fr 1fr",
                  gap: "12px",
                  alignItems: "center",
                  marginBottom: "20px",
                }}
              >
                <div></div>
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <strong>Yes</strong>
                </div>
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <strong>No</strong>
                </div>

                {/* Row 1: Are you coming? */}
                <label>Are you coming?</label>
                <Field type="radio" name="attendance" value="yes" />
                <Field type="radio" name="attendance" value="no" />

                {/* Error */}
                <div></div>
                <div style={{ gridColumn: "2 / span 2", color: "red", fontSize: "12px" }}>
                  <ErrorMessage className="rsvp-error" name="attendance" component="div" />
                </div>

                {/* Row 2: Reminder */}
                {values.attendance === "yes" && (
                  <>
                    <label>Would you like a reminder?</label>
                    <Field type="radio" name="remind" value="yes" />
                    <Field type="radio" name="remind" value="no" />
                  </>
                )}
              </div>

                          {/* Members */}
              {values.attendance === "yes" && (
                   <div>
            <label htmlFor="members" className="rsvp-label">
              Number of People Attending
            </label>
            <Field
              type="number"
              name="members"
              min="1"
              id="members"
              placeholder="Enter number"
              className="rsvp-input-new-number"
            />
            <ErrorMessage
              className="rsvp-error"
              name="members"
              component="div"
              style={{ color: "red", fontSize: "12px", marginTop: "4px" }}
            />
          </div>
              )}

              {/* Suggestion */}
              <div>
                <Field
                  as="textarea"
                  name="suggestion"
                  placeholder="Comments"
                  className="rsvp-input-new-comments"
                />
              </div>



    

              {/* Submit */}
              <div className="submit-rsvp-area">
                <button type="submit" className="rsvp-submit-button-new">
                  Submit
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>

      {/* Footer */}
      <div className="compliment-new">
        Best Wishes from{" "}
        <Link to="https://thurent.com/">
          <img src={thurentlogo} alt="Thurent" style={{ width: "71px" }} />
        </Link>
      </div>
    </div>
  );
};

export default RSVPCard;
